/** Matches {@link LUVIT.Common.Helper.MetadataItemType}.ExternalCourse */
export const METADATA_ITEM_TYPE_EXTERNAL_COURSE = 17;

/** Matches {@link LUVIT.Common.Helper.FieldValueTypes} */
export const METADATA_FIELD_TYPE = {
  Text: 0,
  Multiple: 1,
  Numeric: 2,
  DateTime: 3,
  Bool: 4,
  Dropdown: 5,
  Multiselect: 7,
};
